import template   from './progressbar.html'
import './progressbar.styl'

let component = {
  restrict: 'E',
  bindings: {
    value: '<',
    type: '<'
  },
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/progressbar/progressbar.component.js